import { create } from "zustand";

export type UIStore = {
  editLayer: string[];
  isDetrended: boolean;
  isLandCoverMasked: boolean;
  sidebar: boolean;

  toggleEditLayer: (value: string) => void;
  clearEditLayer: () => void;

  setSidebar: (open: boolean) => void;
  toggleSidebar: () => void;

  setDetrended: (value: boolean) => void;
  toggleDetrended: () => void;

  setLandCoverMasked: (value: boolean) => void;
  toggleLandCoverMasked: () => void;
};

export const useUIStore = create<UIStore>((set) => ({
  editLayer: [],
  isDetrended: false,
  isLandCoverMasked: false,
  sidebar: true,

  toggleEditLayer: (value) =>
    set((s) => ({
      editLayer: s.editLayer.includes(value)
        ? s.editLayer.filter((v) => v !== value)
        : [...s.editLayer, value],
    })),

  clearEditLayer: () => set({ editLayer: [] }),

  setSidebar: (open) => set({ sidebar: open }),
  toggleSidebar: () => set((s) => ({ sidebar: !s.sidebar })),

  setDetrended: (value) => set({ isDetrended: value }),
  toggleDetrended: () => set((s) => ({ isDetrended: !s.isDetrended })),

  setLandCoverMasked: (value) => set({ isLandCoverMasked: value }),
  toggleLandCoverMasked: () =>
    set((s) => ({ isLandCoverMasked: !s.isLandCoverMasked })),
}));
